
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/unsub",
      function () {
        return require("private-next-pages/unsub/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/unsub"])
      });
    }
  